export const handleBlur = () => {
    if (document.getElementById("search-results")) {
        document.getElementById("search-results").classList.add("hide");
    }
}